module.exports = __webpack_public_path__ + "img/maintenance.dee014e.svg";